import { IPageState } from '../../types/redux';

const initialState: IPageState = {
  subdomain: 'www',
  deviceType: 'desktop' as const,
};

export function pageReducer(state: IPageState = initialState) {
  return state;
}
